import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'booleanPipe', standalone: false })
export class BooleanPipe implements PipeTransform {
  constructor() { }
  transform(value: boolean) {
   
    return value ? 'Y' : 'N';
  }
}
